
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';

  @Component({})
  export default class TextWithBorder extends Vue {
    @Prop({required: false, default: 'start'}) justify!: 'center' | 'start' | 'end';
    @Prop({required: false, default: 'center'}) align!: 'center' | 'start' | 'end';
    @Prop({required: true}) html1!: string;
    @Prop({required: false}) html2!: string;
  }
